<button mat-button [matMenuTriggerFor]="animals" mat-raised-button>Select Sign</button>
<mat-menu #animals="matMenu">
  <!-- <button mat-menu-item *ngFor="let sign of signMenuData[0] let i=index" (click)=(gotoPage(sign.signId))> <span class="BOS">{{sign.glyphDisplayCharacter}}</span> {{sign.signName}}</button> -->
  <div *ngFor="let sign of signMenuData[0]; let i=index" >
    <button mat-menu-item *ngIf="i<12" (click)=(gotoPage(sign.signId))> <span class="BOS">{{sign.glyphDisplayCharacter}}</span> {{sign.signName}}</button>
  </div> 


</mat-menu>
